import React, { useState } from 'react';

const tiers = [
  {
    name: 'GRATIS',
    price: '0',
    period: 'kr/mnd',
    desc: 'Perfekt for sporadiske brukere som trenger grunnleggende veinavigasjon.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Bomkalkulator (5 søk/dag)', included: true },
      { text: '1 kjøretøy', included: true },
      { text: 'Sanntids trafikk', included: false },
      { text: 'AutoPASS-integrasjon', included: false },
      { text: 'Ubegrenset bomberegning', included: false },
      { text: 'Prioritert support', included: false }
    ],
    color: 'rgba(138,149,163,0.6)',
    highlight: false,
    cta: 'START GRATIS'
  },
  {
    name: 'NORMAL',
    price: '149',
    period: 'kr/mnd',
    desc: 'For daglige pendlere og sjåfører som vil ha full kontroll over kjørekostnadene.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Ubegrenset bomkalkulator', included: true },
      { text: 'Opptil 3 kjøretøy', included: true },
      { text: 'Sanntids trafikk', included: true },
      { text: 'AutoPASS-integrasjon', included: true },
      { text: 'Månedlig rapport', included: true },
      { text: 'Prioritert support', included: false }
    ],
    color: '#3B6FD4',
    highlight: true,
    cta: 'VELG NORMAL'
  },
  {
    name: 'PREMIUM',
    price: '299',
    period: 'kr/mnd',
    desc: 'For profesjonelle sjåfører, bedrifter og transportselskaper med avanserte behov.',
    features: [
      { text: 'Interaktivt veikart', included: true },
      { text: 'Ubegrenset bomkalkulator', included: true },
      { text: 'Ubegrenset kjøretøy', included: true },
      { text: 'Sanntids trafikk', included: true },
      { text: 'AutoPASS-integrasjon', included: true },
      { text: 'Avanserte rapporter', included: true },
      { text: 'Prioritert 24/7 support', included: true }
    ],
    color: '#E8A838',
    highlight: false,
    cta: 'VELG PREMIUM'
  }
];

const PricingTiers = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="abonnement" style={{ background: '#080E1A', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>
      {/* Background */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(59,111,212,0.05) 0%, transparent 70%)'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: '#3B6FD4',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
          }}>
            <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
            ABONNEMENTER
            <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
          </div>
          <h2 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: 800,
            color: '#EEF0F2',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            margin: '0 0 20px'
          }}>VELG DIN PLAN</h2>
          <p style={{
            fontFamily: 'Lora, serif',
            fontStyle: 'italic',
            fontSize: '1.0625rem',
            color: 'rgba(138,149,163,0.7)'
          }}>Ingen bindingstid. Avbryt når som helst.</p>
        </div>

        {/* Staggered cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2px', alignItems: 'start' }}>
          {tiers?.map((tier, i) => (
            <div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: tier?.highlight ? 'rgba(59,111,212,0.12)' : 'rgba(255,255,255,0.02)',
                border: `1px solid ${tier?.highlight ? 'rgba(59,111,212,0.4)' : 'rgba(255,255,255,0.06)'}`,
                padding: '48px 36px',
                position: 'relative',
                marginTop: i === 1 ? '-20px' : '0',
                transition: 'transform 200ms ease',
                transform: hovered === i ? 'translateY(-8px)' : 'none',
                cursor: 'pointer'
              }}
            >
              {tier?.highlight && (
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#3B6FD4',
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: '#EEF0F2',
                  letterSpacing: '0.15em',
                  padding: '4px 16px',
                  textTransform: 'uppercase'
                }}>MEST POPULÆR</div>
              )}

              {/* Tier name */}
              <div style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.6875rem',
                color: tier?.color,
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                marginBottom: '20px'
              }}>{tier?.name}</div>

              {/* Price */}
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '16px' }}>
                <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '3.5rem', fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.04em', lineHeight: 1 }}>{tier?.price}</span>
                <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: 'rgba(138,149,163,0.6)' }}>{tier?.period}</span>
              </div>

              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(138,149,163,0.7)',
                lineHeight: 1.6,
                marginBottom: '32px',
                minHeight: '56px'
              }}>{tier?.desc}</p>

              {/* Features */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '36px' }}>
                {tier?.features?.map((f, j) => (
                  <div key={j} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                      width: '16px', height: '16px',
                      background: f?.included ? `${tier?.color}20` : 'transparent',
                      border: `1px solid ${f?.included ? tier?.color : 'rgba(255,255,255,0.1)'}`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      {f?.included && <div style={{ width: '6px', height: '6px', background: tier?.color }} />}
                    </div>
                    <span style={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '0.875rem',
                      color: f?.included ? 'rgba(238,240,242,0.75)' : 'rgba(138,149,163,0.3)',
                      textDecoration: f?.included ? 'none' : 'line-through'
                    }}>{f?.text}</span>
                  </div>
                ))}
              </div>

              <a
                href="/login"
                style={{
                  display: 'block',
                  textAlign: 'center',
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '0.8125rem',
                  fontWeight: 700,
                  color: tier?.highlight ? '#EEF0F2' : tier?.color,
                  textDecoration: 'none',
                  padding: '14px',
                  background: tier?.highlight ? '#3B6FD4' : 'transparent',
                  border: `2px solid ${tier?.color}`,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  transition: 'all 200ms ease'
                }}
              >{tier?.cta}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingTiers;
